<template>
  <Dialog
    :visible="showModal"
    :modal="true"
    :closable="false"
    class="payment-success-modal p-dialog-share"
    :showHeader="false"
    :breakpoints="{'1360px': '50vw', '1024px': '60vw', '960px': '90vw', '640px': '91vw'}" :style="{width: '30vw'}"
  >
    <div class="body">
      <div class="text-center my-4">
        <i :class="appendSehattyClass('pi pi-times-circle m-auto color-danger fs-large')"></i>
      </div>
      <div :class="[isHefType ? 'hef-heading' : appendSehattyClass('color-danger'), 'text-center mb-3 fw-bold']">
        {{ heading ?? 'لم تتم عملية التبرع بنجاح'}}
      </div>
      <div :class="appendSehattyClass('text-center mb-4 pb-4 fw-bold border-bottom w-75 m-auto')" v-if="!isHefType">
        {{ message }}
      </div>
      <div class="w-75 m-auto">
        <div class="text-center">
          <button
            id="submit-btn"
            :class="[appendSehattyClass('btn btn-danger btn-lg submit-btn rounded-5 px-5'), { 'hef-submit-btn': isHefType }]"
            type="button"
            @click.prevent="close">
            الصفحة الرئيسية
          </button>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script>
import { appendSehattyClass } from '@/helpers/helpers';
import { DONATION_TYPE } from "@/services/enum.service";
export default {
  name: "DonationFailureDialog",
  props: ["showModal", "message", "heading", "sehatty", "donationType"],
  emits: ["close"],
  data() {
    return {};
  },
  computed: {
    isHefType() {
      return this.donationType === DONATION_TYPE.HEF;
    }
  },
  methods: {
    appendSehattyClass,
    close() {
      if(this.sehatty) {
        this.$router.push("/sehatty");
      }
      else{
        this.$router.push("/");
      }
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.sehatty {
  color: $color-sehatty-gray;
}
.hef-heading {
  color: #000;
  font-size: 1.5rem;
}
.hef-submit-btn {
  background: #007F5C !important;
  border-color: #007F5C !important;
  &:hover {
    background: #006B4F !important;
    border-color: #006B4F !important;
  }
}
.submit-btn {
  background-color: #EA5F6D;
  &.sehatty {
    background-color: $color-complementary-sehatty;
    color: $color-background-light-sehatty;
  }
}

.color-danger {
  color: #EA5F6D;
  &.sehatty {
    color: $color-complementary-sehatty;
  }
}

.fs-large {
  font-size: 70px;
}
</style>
